import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import type { SvgProps } from "react-native-svg";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export const SessionItemsNavEmptyIllustration = (_props: SvgProps) => {
	const theme = useAppTheme();
	return (
		<Box
			width={80}
			height={80}
			borderRadius={40}
			alignItems="center"
			justifyContent="center"
			backgroundColor={theme.colors.secondaryContainer}
		>
			<Icon
				name="filter-remove-outline"
				size={36}
				color={theme.colors.primary}
			/>
		</Box>
	);
};
